import React from "react";
import { Button, dialog, InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import CollectionFormPresenter from "../../../collection-form/CollectionFormPresenter";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import NavBar from "../../../../components/navigation";
import withRouter from "../../../../withRouter";
import FormFactory from "../../../../components/FormFactory";
import { createNotification } from "../../../../createNotification";
class OpenForNominationForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, isUser: false, employee: "" };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      const username = this.getCurrentUser().username;
      const query = {
        where: {
          username: username,
          title: this.state.object.title,
        },
        include: ["employee"],
      };
      const nomiReq = await findObjectUseCase().execute(
        "nomination_request",
        query
      );
      const approveReq = await findObjectUseCase().execute(
        "approve_nomination",
        query
      );

      if (Object.keys(nomiReq).length > 0) {
        for (const employee of nomiReq) {
          this.setState({ isUser: true, employee });
        }
      } else if (Object.keys(approveReq).length > 0) {
        // console.warn("APPROVE: ", approveReq);
        for (const employee of approveReq) {
          this.setState({ isUser: true, employee });
        }
      }
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return "open_for_nomination";
  }

  async submitDialog() {
    const query = {
      where: {
        id: this.state.object.id,
      },
    };
    const nominationReq = await findObjectUseCase().execute(
      "nomination_request",
      query
    );

    const hasEmployee = nominationReq.some(
      (item) => item.employee.id !== this.state.object.employee.id
    );

    const processNomination = async (userArray) => {
      const { object } = this.state;
      const updateObj = {
        username: userArray,
        id: object.id,
        employee: { id: object.employee.id },
        qualification: object.qualification,
        title: object.title,
        description: object.description,
        reason: object.reason,
        count: userArray.length,
      };
      if (hasEmployee) {
        const { id, ...newObj } = updateObj;
        // await upsertUseCase().execute("open_for_nomination", updateObj);
        await upsertUseCase().execute("nomination_request", newObj);
        dialog.close();
        this.showSuccess(
          "Thank you for submitting the nomination! Have a great day."
        );
        this.navigateBack();
        return;
      } else {
        await upsertUseCase().execute("nomination_request", updateObj);
        // await upsertUseCase().execute("open_for_nomination", updateObj);
        dialog.close();
        this.showSuccess(
          "Thank you for submitting the nomination! Have a great day."
        );
        this.navigateBack();

        //  CREATE NOTIFICATION
        const NOTIFICATION_MESSAGE = `You have a new notification for the Recognition Request`;
        const NOTIFICATION_RECEIVER = ["role:Super Admin"];
        const NOTIFICATION_REDIRECT = "nomination";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT
        );
        return;
      }
    };

    if (nominationReq.length > 0 && !hasEmployee) {
      for (const item of nominationReq) {
        const username = [this.getCurrentUser().username, ...item.username];
        await processNomination(username);
      }
    } else {
      const username = [this.getCurrentUser().username];
      await processNomination(username);
    }
  }

  async handleSendNomination() {
    dialog.fire({
      html: (
        <div className="p-2">
          <h4>Send Nomination?</h4>
          <hr />
          <p style={{ margin: "2rem 0" }}>Click confirm to proceed.</p>
          <hr />
          <div className="w-100 d-flex justify-content-end gap-4 mb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.submitDialog()}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  render() {
    const object = this.state.object;
    // console.warn("OBJECT: ", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const validation = Object.keys(object).length > 0 && this.state.isUser;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  // onSubmit={this.onSubmitForm.bind(this)}
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSendNomination();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          schema={schema}
                          object={object}
                          disabled={true}
                          onChange={this.onChange.bind(this)}
                          excludeFields={["employee", "reason"]}
                        />
                        {/* {validation ? (
                          <div>
                            <label className="mb-2">Employee</label>
                            <InputFactory
                              type="String"
                              disabled={true}
                              value={this.state.employee}
                            />
                          </div>
                        ) : ( */}
                        <FormFactory
                          schema={schema}
                          object={validation ? this.state.employee : null}
                          onChange={this.onChange.bind(this)}
                          disabled={validation}
                          excludeFields={[
                            "title",
                            "description",
                            "qualification",
                          ]}
                        />
                        {/* )} */}
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    {validation ? null : (
                      <button
                        type="submit"
                        className="btn btn-primary fs-sm me-3"
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        Send
                      </button>
                    )}

                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OpenForNominationForm);
